import { CurrentTariffDto } from "services/organizationBranch/restModels";

export type TariffStatus = "active" | "overdue" | "expired";

// За неделю до списания кабинет начинает показывать обратный отсчёт.
const PAYMENT_SOON_DAYS = 7;

const DAY_MS = 24 * 60 * 60 * 1000;
const HOUR_MS = 60 * 60 * 1000;

/*
* overdue — оплата просрочена, но меню ещё живут (у заведения есть пара недель на оплату);
* expired — истёк и этот срок, меню выключены.
* */
export const tariffStatusOf = (tariff: CurrentTariffDto, now: number): TariffStatus => {
    if (now <= tariff.nextPaymentDate) return "active";

    return now > tariff.menusActiveTillDate ? "expired" : "overdue";
};

// Остаток до даты: «5д», а в последние сутки — «7ч».
export const timeLeftLabel = (until: number, now: number): string => {
    const left = until - now;

    if (left <= 0) return "";

    if (left < DAY_MS) return `${Math.floor(left / HOUR_MS)}ч`;

    return `${Math.floor(left / DAY_MS)}д`;
};

export const isPaymentSoon = (tariff: CurrentTariffDto, now: number): boolean =>
    tariff.nextPaymentDate - now <= PAYMENT_SOON_DAYS * DAY_MS;

/*
* Уровни тарифа, дающие доступ к функции. Возможности не отключаются в день списания: пока
* меню живы (статус active или overdue), уровень считается действующим.
* */
const REQUIRED_TARIFF_TYPES: Record<string, string[]> = {
    Basic: ["Basic", "Advanced"],
    Advanced: ["Advanced"],
};

export const isTariffLevelActive = (
    tariff: CurrentTariffDto,
    level: string,
    now: number
): boolean => {
    if (tariffStatusOf(tariff, now) === "expired") return false;

    // Простой уровень доступен на любом действующем тарифе — тип для него не проверяем.
    const requiredTypes = REQUIRED_TARIFF_TYPES[level];

    return !requiredTypes || requiredTypes.indexOf(tariff.type) !== -1;
};
